module.exports = __webpack_public_path__ + "img/icon-startup-light-blue.bc7927c8.svg";